import { useEffect, useState } from 'react';
import { githubService } from '@/services/github';
import type { Drone } from '@/types/drones';

interface UseProductsReturn {
  products: Drone[];
  loading: boolean;
  error: Error | null;
  refetch: () => Promise<void>;
}

export function useProducts(category: string): UseProductsReturn {
  const [products, setProducts] = useState<Drone[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await githubService.listProducts(category);
        setProducts(data);
      } catch (err) {
        setError(err as Error);
        console.error('Error fetching products:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [category]);

  const refetch = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await githubService.listProducts(category);
      setProducts(data);
    } catch (err) {
      setError(err as Error);
      console.error('Error fetching products:', err);
    } finally {
      setLoading(false);
    }
  };

  return {
    products,
    loading,
    error,
    refetch,
  };
}
